import { render, staticRenderFns } from "./TabMinhasSimulacoes.vue?vue&type=template&id=3cd75bd4&"
import script from "./TabMinhasSimulacoes.vue?vue&type=script&lang=js&"
export * from "./TabMinhasSimulacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports